import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit, CiViewList } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../../../../../utils/checkAccess";
import { BiShow } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { setAppError } from "../../../../../../../../../store/userSlice";

export default function TableTerms({
  titles = ["Sl No.", "Particulars", "Remarks", "Action"],
  setAllTerms,
  allTerms,
  setData,
}) {
  const dispatch = useDispatch();
  const [deletedArrayList, SetDeletedArrayList] = useState([]);
  const handleInputChange = (id, field, value) => {
    const updatedTerms = allTerms.map((data) => {
      if (data?.id == id) {
        return { ...data, [field]: value };
      }
      return data;
    });
    setAllTerms(updatedTerms);
  };

  const handleDelete = (id) => {
    if (allTerms?.length <= 1) {
      return dispatch(
        setAppError({
          msg: "Atleast one term is needed.",
        })
      );
    }

    const updatedTemplate = allTerms?.filter((item) => item.id != id);
    allTerms.filter((data) => {
      if (data?.id == id) {
        if (data?.type !== "new") {
          SetDeletedArrayList((prev) => [
            ...prev,
            { terms_and_conditions_id: data.id },
          ]);
        }
      }
    });
    setAllTerms(updatedTemplate);
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      terms_and_conditions_delete: deletedArrayList,
    }));
  }, [deletedArrayList]);

  return (
    <>
      <div className="p-5 w-full overflow-x-auto ">
        <div
          className={`grid justify-items-center min-w-fit items-center grid-cols-table-4 auto-cols-min gap-5 p-6 bg-white  w-full   rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}

          {allTerms?.length <= 0 && (
            <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-4">
              <p>Loading</p>
              <CgSpinner className="animate-spin" />
            </div>
          )}

          {allTerms?.map((list, index) => (
            <React.Fragment key={list.id}>
              <p>{Number(index) + 1}</p>
              <textarea
                rows={2}
                className="textarea textarea-sm textarea-bordered w-full"
                type="text"
                defaultValue={list?.particular}
                required
                onChange={(e) =>
                  handleInputChange(
                    list?.id,
                    "particular",
                    String(e.target.value).toUpperCase()
                  )
                }
              />
              <textarea
                rows={2}
                className="textarea textarea-sm textarea-bordered w-full textTransformNone"
                type="text"
                defaultValue={list?.remark}
                required
                onChange={(e) =>
                  handleInputChange(list?.id, "remark", String(e.target.value))
                }
              />
              <div className="flex gap-3 min-w-fit">
                <button
                  type="button"
                  className="p-1 px-2 rounded-md ring-1 ring-slate-300"
                  onClick={() => handleDelete(list.id)}
                >
                  <MdDeleteOutline size={"1.4rem"} />
                </button>
              </div>
              <hr className="border-[1.5px] border-slate-100 w-full col-span-4" />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
